export default {
  computed: {
    configs() {
      const M_PROPINSI = this.masters.propinsi || {};
      const M_KOTA = this.masters.kota || {};
      return {
        instansi: {
          selector: ['instansi_k_propinsi', 'instansi_k_kota'],
          required:
            this.form.k_beda_instansi_psp === 51001 ? ['instansi_k_propinsi', 'instansi_k_kota'] : [false, false],
          label: ['Provinsi Instansi', 'Kabupaten/Kota Instansi'],
          options: [M_PROPINSI, M_KOTA],
          grid: [{ cols: 6 }, { cols: 6 }],
        },
        instansi_tugas: {
          selector: ['tugas_k_propinsi', 'tugas_k_kota'],
          required: this.form.k_beda_tugas_psp === 51001 ? ['tugas_k_propinsi', 'tugas_k_kota'] : [false, false],
          label: ['Provinsi Instansi Induk', 'Kabupaten/Kota Instansi Induk'],
          options: [M_PROPINSI, M_KOTA],
          grid: [{ cols: 6 }, { cols: 6 }],
        },
      };
    },

    pspProfil() {
      return this.$getDeepObj(this.initValue, 'psp_profil') || {};
    },

    instansiDaftar() {
      return [
        {
          type: 'textView',
          label: `Nama Instansi`,
          value: this.$getDeepObj(this.pspProfil, 'instansi_nama') || '',
          grid: { cols: 12, lg: 6 },
        },
        {
          type: 'textView',
          label: `Website Instansi`,
          value: this.$getDeepObj(this.pspProfil, 'instansi_situs') || '',
          grid: { cols: 12, lg: 6 },
        },
        {
          type: 'textView',
          label: `Alamat Instansi`,
          value: this.$getDeepObj(this.pspProfil, 'instansi_alamat') || '',
          grid: { cols: 12, lg: 6 },
        },
        {
          type: 'textView',
          label: `Provinsi Instansi`,
          value: this.$getDeepObj(this.pspProfil, 'm_propinsi_instansi.keterangan') || '',
          grid: { cols: 12, lg: 6 },
        },
        {
          type: 'textView',
          label: `Kota Instansi`,
          value: this.$getDeepObj(this.pspProfil, 'm_kota_instansi.keterangan') || '',
          grid: { cols: 12, lg: 6 },
        },
      ];
    },

    instansiSekarang() {
      return [
        {
          type: 'VRadio',
          name: 'k_beda_instansi_psp',
          label: 'Apakah instansi Anda saat ini berubah dari yang ada di CV saat pendaftaran?',
          hint: 'wajib diisi',
          required: true,
          items: [
            { text: 'Ya', value: 51001 },
            { text: 'Tidak', value: 51002 },
            { text: 'Tidak Memiliki Instansi', value: 51003 },
          ],
          grid: { cols: 12 },
        },
        {
          exist: { status: this.form.k_beda_instansi_psp === 51001 },
          type: 'VTextField',
          name: 'instansi_nama',
          label: 'Nama Instansi',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          exist: { status: this.form.k_beda_instansi_psp === 51001 },
          type: 'VTextField',
          name: 'instansi_situs',
          label: 'Website Instansi',
          grid: { cols: 12, md: 6 },
          required: +this.form.k_beda_instansi_psp === 51001,
          outlined: true,
          dense: true,
          singleLine: true,
          hideDetails: true,
        },
        {
          exist: { status: this.form.k_beda_instansi_psp === 51001 },
          type: 'VTextarea',
          name: 'instansi_alamat',
          label: 'Alamat Instansi',
          hint: 'wajib diisi',
          grid: { cols: 12 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          exist: { status: this.form.k_beda_instansi_psp === 51001 },
          type: 'cascade',
          labelColor: 'secondary',
          configs: this.configs && this.configs['instansi'],
          grid: { cols: 12 },
        },
      ];
    },

    instansiInduk() {
      return [
        {
          type: 'VRadio',
          name: 'k_beda_tugas_psp',
          label: 'Apakah instansi Saat Ini sama dengan Instansi Induk Anda?',
          hint: 'wajib diisi',
          required: true,
          items: [
            { text: 'Ya', value: 51002 },
            { text: 'Tidak', value: 51001 },
            { text: 'Tidak Memiliki Instansi', value: 51003 },
          ],
          grid: { cols: 12 },
        },
        {
          exist: { status: this.form.k_beda_tugas_psp === 51001 },
          type: 'VTextField',
          name: 'tugas_nama',
          label: 'Nama Instansi',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          exist: { status: this.form.k_beda_tugas_psp === 51001 },
          type: 'VTextField',
          name: 'tugas_situs',
          label: 'Website Instansi',
          grid: { cols: 12, md: 6 },
          required: +this.form.k_beda_tugas_psp === 51001,
          outlined: true,
          dense: true,
          singleLine: true,
          hideDetails: true,
        },
        {
          exist: { status: this.form.k_beda_tugas_psp === 51001 },
          type: 'VTextarea',
          name: 'tugas_alamat',
          label: 'Alamat Instansi',
          hint: 'wajib diisi',
          grid: { cols: 12 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          show: { status: this.form.k_beda_tugas_psp === 51001 },
          type: 'cascade',
          labelColor: 'secondary',
          configs: this.configs && this.configs['instansi_tugas'],
          grid: { cols: 12 },
        },
      ];
    },
  },
};
